import { render } from "./LogoutContent.vue?vue&type=template&id=9cc4ef84"
import script from "./LogoutContent.vue?vue&type=script&lang=js"
export * from "./LogoutContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__